import { createSignal } from "solid-js";
import EventAnalytics from "~/js/utilities/EventAnalytics";

const [getIsCreateTeamModalVisible, setIsCreateTeamModalVisible] = createSignal(false);

export const showCreateTeamModal = () => {
	EventAnalytics.team.createTeam.modalOpened();
	setIsCreateTeamModalVisible(true);
};

export const hideCreateTeamModal = () => {
	setIsCreateTeamModalVisible(false);
};

export const getIsModalVisible = () => {
	return getIsCreateTeamModalVisible();
};
